import CircularProgress from "@material-ui/core/CircularProgress";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import clsx from "clsx";
import React from "react";
import { animated, useSpring } from "react-spring";
import { fadeIn } from "../../styles/springs";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      marginTop: theme.spacing(5),
      textAlign: "center",
      width: "100%",
      "& > * + *": {
        marginTop: theme.spacing(2),
      },
    },
    viewportCentered: {
      marginTop: 0,
      "& .MuiCircularProgress-root": {
        position: "fixed",
        margin: "auto",
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
      },
    },
  }),
);

type CustomProgressVariant = "viewportCentered" | "regular";

interface CustomProgressProps {
  className?: string;
  variant?: CustomProgressVariant;
}

const CustomProgress = ({ className, variant = "regular" }: CustomProgressProps) => {
  const classes = useStyles();
  const springProps = useSpring(fadeIn);

  return (
    <animated.div
      className={clsx([classes.root, variant === "viewportCentered" && classes.viewportCentered, className])}
      style={springProps}
    >
      <CircularProgress color="secondary" />
    </animated.div>
  );
};

export default CustomProgress;
